module.exports = __webpack_public_path__ + "img/pin.3548cdc0.svg";